import { render, staticRenderFns } from "./addnewTalkPoint.vue?vue&type=template&id=36e0a6a0&scoped=true&"
import script from "./addnewTalkPoint.vue?vue&type=script&lang=ts&"
export * from "./addnewTalkPoint.vue?vue&type=script&lang=ts&"
import style0 from "./addnewTalkPoint.vue?vue&type=style&index=0&id=36e0a6a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e0a6a0",
  null
  
)

export default component.exports